import React from "react";
import { Box } from "@chakra-ui/react";

export default function ProfileCard({ 
  children, 
  spacing = 6,
  ...props 
}) {
  return (
    <Box
      bg="white"
      p={spacing}
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="16px"
      shadow="sm"
      _hover={{
        shadow: "md",
        borderColor: "gray.300",
      }}
      transition="all 0.2s ease"
      {...props}
    >
      {children}
    </Box>
  );
}